$(function () {

		$('.smooth-form input:text, .smooth-form select, .smooth-form textarea').not('.not-smooth-form').bind('focus', function () {
			$(this)
				.closest('li')
					.addClass('focus')
				.end()
				.one('blur', function () {
					$(this)
						.closest('li')
							.removeClass('focus')
						.end()
						.validate();
				});
		});	

	// FORM FIELD VALIDATE	
	/// REFACTOR [Skylar] - Refactor to use Origin.Validate like in DUSA so all the validation can be centralized.	
	$.fn.validate = function () {
		return this.each(function () {
			var $self = $(this);
			var validationType = $self.dataset('validationType');
			var errorMessage = $self.dataset('errorMessage');

			var $li = $self.closest('li');

			// Make sure validation type is set on the input
			if (!validationType || validationType == '') {  // Don't do anything if the validation type is not set
				return;
			}

			if (validationType == 'notEmpty') {
				if (!$self.val() || !$self.val.length) {
					$li.addClass('error');
					$li.attr('title', errorMessage || 'Please enter a value.');
				}
				else {
					$li.removeClass('error');
					$li.attr('title', 'Value was entered correctly.');
				}
			} else if (validationType == 'email') {
				var emailRegex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,128}$/;
				if (emailRegex.test($.trim($self.val())) == false) {
					$li.addClass('error');
					$li.attr('title', errorMessage || 'Please enter a valid email address.');
				}
				else {
					$li.removeClass('error');
					$li.attr('title', 'Email address was entered correctly.');
				}
			} else if (validationType == 'phone') {
				var phoneRegex = /^([0-9.)(-]+)$/;
				if (phoneRegex.test($.trim($self.val())) == false) {
					$li.addClass('error');
					$li.attr('title', errorMessage || 'Please enter a valid phone number.');
				}
				else {
					$li.removeClass('error');
					$li.attr('title', 'Phone number was entered correctly.');
				}
			} else {
				log('validation error: unknown validation type');
			}
		});
	};
});